import { atom } from 'jotai';
import { IABTest } from '@lemon8/web-app-shared/atom';

export const $SharerABTest = atom<IABTest>({
  versions: '',
  parameters: {},
});

$SharerABTest.debugLabel = '$SharerABTest';
